import React from 'react';
import { SvgIcon } from '@material-ui/core/';

export function CancelIcon(props: any) {
    return (
        <SvgIcon {...props}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 11.9999C21 16.9704 16.9706 20.9999 12 20.9999C7.02944 20.9999 3 16.9704 3 11.9999C3 7.02931 7.02944 2.99988 12 2.99988" stroke="#292929" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/><path d="M19 5L16 8" stroke="#292929" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/><path d="M15.9999 4.99998L19 7.99985" stroke="#292929" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/></svg>
        </SvgIcon>
    );
}